import { render, staticRenderFns } from "./stand_list.vue?vue&type=template&id=765b0ca1&scoped=true&"
import script from "./stand_list.vue?vue&type=script&lang=js&"
export * from "./stand_list.vue?vue&type=script&lang=js&"
import style0 from "./stand_list.vue?vue&type=style&index=0&id=765b0ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b0ca1",
  null
  
)

export default component.exports